import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {useDispatch} from 'react-redux';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import {showGlobalMessage} from '../../../_common/components/GlobalMessage/actions/showGlobalMessage';
import {can} from '../../../_common/components/Permissions';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import {deleteContact, restoreContact} from '../../actions/ContactsActions';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {messages as M} from '../../../../../_metronic/i18n/messages';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';
import ModalHeader from '../../../_common/components/ModalHeader';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';

export default function PopupDeleteRestoreContact({data}) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const contactName = [data?.firstName, data?.lastName].filter(Boolean).join(' ');
  const isDeleted = data?.deleted ? data.deleted : false;
  const handleAction = async () => {
    const result = data.deleted
      ? await dispatch(restoreContact(data.contactID))
      : await dispatch(deleteContact(data.contactID));
    if (result.errorCode < 0) {
      await dispatch(showGlobalMessage('error', M['-1']));
    }
    handleCloseModal();
  };
  const prefix = 'contacts-popup';
  const icon = `media/common/${isDeleted ? 'Restore_green.svg' : 'Delete_red.svg'}`;
  const message = isDeleted
    ? <FormattedMessage
      id={`${prefix}-restore-header`}
      defaultMessage={`Are you sure you want to restore {name}?`}
      values={{name: contactName}}
    />
    : <FormattedMessage
      id={`${prefix}-delete-header`}
      defaultMessage={`Are you sure you want to delete {name}?`}
      values={{name: contactName}}
    />;
  const tooltip = isDeleted ? TTS.RESTORE_CONTACT : TTS.DELETE_CONTACT;
  const buttonApprove = isDeleted
    ? <FormattedMessage id={`${prefix}-restore-yes`} defaultMessage="Restore"/>
    : <FormattedMessage id={`${prefix}-delete-yes`} defaultMessage="Delete"/>;

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={isDeleted ? 'success' : 'error'}
        title={tooltip}
        disabled={!can(T.FULL, S.CONTACTS_PAGE) || !data.contactID}
        onClick={handleShowModal}
        label={<img src={icon} alt="action"/>}
        customClassnames={'mx-2'}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'md'}>
        <ModalHeader header={message}/>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            onClick={handleCloseModal}
            label={<FormattedMessage id="no" defaultMessage="No"/>}
            customClassnames={buttonCancel}
          />
          <ButtonAction
            onClick={() => handleAction()}
            useIcon={'/media/common/Check-in-circle_white.svg'}
            label={buttonApprove}
            customClassnames={buttonSubmit}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
}
